export default __webpack_public_path__ + "static/media/laboratory.28cb3ef8.webp";